import logo from './logo.jpg'
import newsImage from './banner.png'

export const theme = {
  color: {
    primary: "#004289",
    primaryHover: "#003b7b",
  },
  logoImage: logo,
  backend: "https://lindeverlag.epaper-publishing-one.de/",
  directory: "/kiosk",
  header: {
    customer: "",
    title: "Linde MEDIA",
    lineHeader: true,
  },
  accToolbar: true,
  newsSlider: {
    image: newsImage
  },
  info: [
    {
      text: 'Impressum',
      link: 'https://shop.lindeverlag.at/impressum/c-652'
    },
    {
      text: 'Datenschutz',
      link: 'https://shop.lindeverlag.at/datenschutz/c-655'
    },
  ],
  login: {
    type: "internal",
    subscriptionTitle: "Abo",
    subscriptionText: "Sie haben noch kein Abonnement? Schließen Sie jetzt Ihr Abonnement für die Linde-Zeitschrift Ihrer Wahl ab und erhalten Sie vollen Zugriff auf die aktuelle Ausgabe, die künftigen Ausgaben und unser Archiv.",
    links: [{
      id: 1,
      text: 'Zu den Linde-Zeitschriften im Shop',
      url: "https://shop.lindeverlag.at/zeitschriften/c-12"
    },
    {
      id: 2,
      text: '„SWK - Die Nr. 1 im Steuerrecht!“ abonnieren',
      url: "https://shop.lindeverlag.at/zeitschrift/swk-1?page_id=12"
    },
    {
      id: 2,
      text: 'Zu „LinDa“, der Rechercheplattform des Linde Verlags',
      url: "https://linda.lindeverlag.at/"
    }
    ]
  }
};